import dashboard from "./dashboard";

import contentgeneration from "./contentgeneration";
import keywordsuggestion from "./keywordsuggestion";
import ppccampaign from "./ppccampaign";
import optimization from "./optimization";
import technicaloptimization from "./technicaloptimization";
import emailmarketing from "./emailmarketing";
import seo from "./seo";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    seo,
    contentgeneration,
    keywordsuggestion,
    ppccampaign,
    emailmarketing,
    optimization,
    technicaloptimization,
  ],
};

export default menuItems;
